import { REPORTING } from 'reporting/constants';

export const AGGREGATION_OPTIONS: Record<string, string> = {
    average: 'average',
    count: 'count',
    percentage: 'percentage',
    sum: 'sum',
    max: 'max',
    min: 'min',
    ratio: 'ratio',
    percent_max: 'pct_max',
    percent_average: 'pct_average',
    na: 'na',
};

export const GROUP_BY_OPTIONS: Record<string, string> = {
    activity: 'activity',
    period: 'period',
    time: 'time',
    distance: 'distance',
    total: 'total',
};

export const LOAD_SCORE_PARAMS = [
    REPORTING.distance,
    REPORTING.high_speed_distance,
    REPORTING.accel_and_decel_efforts,
    REPORTING.meterage_per_minute,
    REPORTING.high_speed_distance_per_min,
    REPORTING.accel_and_decel_efforts_per_minute,
];
